import React, { useEffect } from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import './OrderSuccess.css';

const OrderSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { orderId, paymentId, amount, date } = location.state || {};

  useEffect(() => {
    if (!location.state) {
      navigate('/');
    }
  }, [location.state, navigate]);

  if (!location.state) return null;

  return (
    <div className="order-success-page">
      <div className="success-card">
        <div className="success-icon-wrapper">
          <svg className="success-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7"></path>
          </svg>
        </div>

        <h1 className="success-title">Order Placed!</h1>
        <p className="success-message">
          Thank you for your purchase. Your order has been confirmed and will be delivered soon.
        </p>

        <div className="receipt-card">
          <div className="receipt-row">
            <span className="receipt-label">Order ID</span>
            <span className="receipt-value">{orderId}</span>
          </div>
          <div className="receipt-row">
            <span className="receipt-label">Payment ID</span>
            <span className="receipt-value">{paymentId}</span>
          </div>
          <div className="receipt-row">
            <span className="receipt-label">Date</span>
            <span className="receipt-value">{new Date(date).toLocaleDateString()}</span>
          </div>
          <div className="receipt-row">
            <span className="receipt-label">Amount Paid</span>
            <span className="receipt-value highlight">₹{amount.toFixed(2)}</span>
          </div>
        </div>

        <div className="action-buttons">
          <Link to="/" className="primary-btn">
            Continue to dashboard
          </Link>
          {/* Placeholder for future My Orders link */}
          {/* <Link to="/orders" className="secondary-btn">
            View My Orders
          </Link> */}
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;
